"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("../../../classnames"));
var SelectFieldCaret = react_1.default.memo(function (_a) {
    var open = _a.open;
    return (react_1.default.createElement("div", { className: classnames_1.default("chq-ffd--sl--caret", { "chq-ffd--sl--caret-flip": open }) }));
});
exports.default = SelectFieldCaret;
